module.exports = __webpack_public_path__ + "static/media/taobao-guide.586e4f7d.png";